export default {
	name: 'stat',
	title: 'Statistic',
	type: 'object',
	fields: [
		{
			name: 'value',
			title: 'Value',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'label',
			title: 'Label',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'icon',
			title: 'Icon',
			description: 'Icon name from Lucide React',
			type: 'string',
		},
	],
};
